import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "listFooter"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "seeAll",
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    (...args) => _ctx.gotToNotificationPage && _ctx.gotToNotificationPage(...args))
  }, _toDisplayString(_ctx.$t("notification.see.all")), 1)]);
}